import React, {useContext, useEffect, useState, useCallback} from 'react';
import {clone, filterStories, getLocalStorage, isValidString} from './Utils';
import NavBar from './NavBar';
import ApplicationContext from './ApplicationContext';
// TODO:  Comment out the pyament button stuff, maybe this will be reintroduced when we add a new payment tier.
// import CreditCardForm from './CreditCardForm';
import "../assets/css/stories.css"

const Stories = (props) => {
	const [storiesBase, setStoriesBase] = useState();
	const [storiesFilter, setStoriesFilter] = useState();
	const [, setCurrentSelection] = useState();
	const data = useContext(ApplicationContext);

	// TODO:  Comment out the pyament button stuff, maybe this will be reintroduced when we add a new payment tier.
	// const [enableStripe, setEnableStripe] = useState();
	const [authToken, setAuthToken] = useState(getLocalStorage('token'));
    // const [isDialogOpen, setIsDialogOpen] = useState(false);

	const handlePaymentClick = () => {
        // setIsDialogOpen(true);
    };
  
    // const closeDialog = () => {
    //     setIsDialogOpen(false);
    // };

	const [monetized, setMonetized] = useState(false);
	const onSelectionChange = (selection) => {
		console.log('DEBUG:  called onSelectionChange');
		updateStories(selection);
	};

	const updateMonetizedFlagForCurrentSelection = useCallback(async (selection) => {
		// console.log("selection = ", selection);
		// console.log(`data.choicePairsList = ${JSON.stringify(data.choicePairsList)}`,);

		const found = Object.values(data.choicePairsList)
			.flatMap(entries => entries)
			.find(entry => entry.KEYWORD_SEARCH === selection);

		// console.log('DEBUG:  onSelectionChange - ', selection['keyword']);
		// console.log("DEBUG: found = ", found, found?.length);
		if (found) {
			setMonetized(found.monetized === "1" ? true : false);
			// console.log('DEBUG:  onSelectionChange - ', found[0][1]?.monetized === "1");
		}
	}, [data.choicePairsList]);

	const updateStories = useCallback(async (selection) => {
		const keywordSearch = getLocalStorage("KEYWORD_SEARCH");
		if (!selection) {
			selection = keywordSearch;
		}

		let foundEntry;
		if (data.choicePairsList) {
			foundEntry = Object.values(data.choicePairsList)
				.flatMap(entries => entries)
				.find(entry => entry.KEYWORD_SEARCH === selection);			  
		}

		if (foundEntry && data.BASE_URL) {	
			if (selection) {
				updateMonetizedFlagForCurrentSelection(selection);
				setCurrentSelection(selection);
			}
			else {
				const currentSelection = {index: parseInt(keywordSearch), keyword: foundEntry?.KEYWORD_SEARCH, label: foundEntry?.KEYWORD_SEARCH};
				updateMonetizedFlagForCurrentSelection(currentSelection);
				setCurrentSelection(currentSelection);
			}

			// console.log(foundEntry?.monetized);
			// console.log(foundEntry?.monetized === '1' && isValidString(authToken));
			if ((foundEntry?.monetized === '0') || (foundEntry?.monetized === '1' && isValidString(authToken))) {
				let url = data.BASE_URL + "index.php/news_data/get_news_data/" + encodeURIComponent(foundEntry?.KEYWORD_SEARCH);
	
				let response = await fetch(url);
				let res = await response.json();

				setStoriesBase(res || []);
			}
		}
	}, [data, updateMonetizedFlagForCurrentSelection, authToken]);

	// useEffect(() => {
	// 	setEnableStripe(data.enableStripe);
	// }, [data.enableStripe]);

	useEffect(() => {
		updateStories();
	}, [data.BASE_URL, data.choicePairsList, data.resetTopStoriesCount, updateStories]);

	useEffect(() => {
		// console.log(storiesBase)
		setStoriesFilter(filterStories(storiesBase));
	}, [storiesBase]);

	useEffect(() => {
		if (!props.topStories) {
			setStoriesFilter([]);
	
			const tmpList = filterStories(storiesBase);
			if (tmpList) {
				// console.log('DEBUG:  tmpList - ', tmpList);
				tmpList?.forEach((e,i,arr) => {
					arr[i].topStoriesUI = e.topStories === "1" ? "1" : "";
					arr[i].tickerStoriesUI = e.tickerStories === "1" ? "1" : "";
				});
				setStoriesFilter(tmpList);
			}

			// console.log('DEBUG:  storiesBase changed')
		}
		else {
			// console.log("DEBUG", "props.topStories === true")
			// console.log('DEBUG:  true true true true true true true true true ')
			setStoriesFilter([]);

			if (data.TopStoriesResults && data.TopStoriesResults.length > 0) {
				setStoriesFilter(data.TopStoriesResults);
			}
		}
	}, [props.topStories, data.TopStoriesResults, storiesBase]);

	// TODO:  Comment out the patent buttons, maybe we will bring this back at some point.
	// const grantedPatents = (e) => {
	// 	e.preventDefault();
		
	// 	// Filter out all storiesBase that have the following keywords in the titles
	// 	const lookupTags = [["granted", "patent"],
	// 		["allow"],
	// 		["allowance"],
	// 		["issued", "patent"],
	// 		["given", "patent"],
	// 		["approved", "patent"],
	// 		["approve"],
	// 		["approved"],
	// 		["approves"],
	// 		["new", "patent"]
	// 	];
		
	// 	// console.log('DEBUG:  grantedPatents')
	// 	setStoriesFilter(filterStories(storiesBase, lookupTags));
	// };

	// TODO:  Comment out the patent buttons, maybe we will bring this back at some point.
	// const provisionalPatents = (e) => {
	// 	e.preventDefault();
	
	// 	// Filter out all storiesBase that have the following keywords in the titles
	// 	const lookupTags = [["provisional", "patent"],
	// 		["provisional"],
	// 		["file", "patent"],
	// 		["files", "patent"],
	// 		["applies", "patent"],
	// 		["apply", "patent"],
	// 		["patent", "application"]
	// 	];

	// 	// console.log('DEBUG:  provisionalPatents')
	// 	setStoriesFilter(filterStories(storiesBase, lookupTags));
	// };

	// curl -d "keywordSearch=patent news&LINK=./articles/CBMiTWh0dHA6Ly93d3cuZm9zc3BhdGVudHMuY29tLzIwMjMvMDkvbmV3LWZ0Yy1pbml0aWF0aXZlLWFuZC12ZXJ5LXJlY2VudC1kYy5odG1s0gEA?hl=en-US&gl=US&ceid=US%3Aen" http://localhost/~jeff/news-collector/web/index.php/news_data/update_news_data_top_stories
	const [tappedTopStoryEntry, setTappedTopStoryEntry] = useState();
	useEffect(() => {
		if (tappedTopStoryEntry && data.BASE_URL) {
			// console.log(`DEBUG:  ${JSON.stringify(tappedTopStoryEntry)}`);
			(async() => {
				const entry = tappedTopStoryEntry?.entry;
				const index = tappedTopStoryEntry?.index;
				const url = data.BASE_URL + "index.php/news_data/update_news_data_top_stories";
				const param = new URLSearchParams();
				const entries = Object.entries({ KEYWORD_SEARCH: entry?.keywordSearch, LINK: entry?.link })
				entries.forEach(entry => {
					if ( entry.length === 2 ) {
						param.append(...entry);
					}
				});
				const requestOptions = {
					method: 'POST',
					body: param,
				};
				const response = await fetch(url, requestOptions);
				const res = await response.json();
				// console.log('DEBUG: ' + res.COUNT, typeof res.COUNT)
				if (res.COUNT === 1) {
					// console.log(`DEBUG: ${JSON.stringify(res)}`);
					let tmpList = clone(storiesFilter);
					tmpList[index]['topStoriesUI'] = res.TOP_STORIES === "1" ? "1" : "";
					// console.log('DEBUG:  detected changes on tappedTopStoryEntry');
					setStoriesFilter(tmpList);
				}
				setTappedTopStoryEntry(undefined);
			})();
		}
	}, [data.BASE_URL, tappedTopStoryEntry, storiesFilter]);

	// const [tappedTickerStoryEntry, setTappedTickerStoryEntry] = useState();	
	// useEffect(() => {
	// 	if (tappedTickerStoryEntry) {
	// 		// console.log(`DEBUG:  ${JSON.stringify(tappedTickerStoryEntry)}`);
	// 		(async() => {
	// 			const entry = tappedTickerStoryEntry?.entry;
	// 			const index = tappedTickerStoryEntry?.index;
	// 			const url = data.BASE_URL + "index.php/news_data/update_news_data_ticker_stories";
	// 			const param = new URLSearchParams();
	// 			const entries = Object.entries({ KEYWORD_SEARCH: entry?.keywordSearch, LINK: entry?.link })
	// 			entries.forEach(entry => {
	// 				if ( entry.length === 2 ) {
	// 					param.append(...entry);
	// 				}
	// 			});
	// 			const requestOptions = {
	// 				method: 'POST',
	// 				body: param,
	// 			};
	// 			const response = await fetch(url, requestOptions);
	// 			const res = await response.json();
	// 			// console.log('DEBUG: ' + res.COUNT, typeof res.COUNT)
	// 			if (res?.COUNT === 1) {
	// 				// console.log(`DEBUG: ${JSON.stringify(res)}`);
	// 				let tmpList = clone(storiesFilter);
	// 				tmpList[index]['tickerStoriesUI'] = res.TICKER_STORIES === "1" ? "1" : "";
	// 				// console.log('DEBUG:  detected changes on tappedTickerStoryEntry');
	// 				setStoriesFilter(tmpList);
	// 			}
	// 		})();
	// 	}
	// }, [tappedTickerStoryEntry]);

	// const [likeButtonEnabled, setLikeButtonEnabled] = useState(false);
	const [likeButtonEntry, setLikeButtonEntry] = useState({});
	useEffect(() => {
		if (data.BASE_URL) {
			((async() => {
				const url = data.BASE_URL + "index.php/news_data/update_news_data_like_count";
				let parms;
				if (likeButtonEntry && likeButtonEntry['keywordSearch'] && likeButtonEntry['link']) {
					parms = {
						KEYWORD_SEARCH:likeButtonEntry['keywordSearch'],
						LINK:likeButtonEntry['link']
					};
					var formBody = [];
					for (var property in parms) {
					  var encodedKey = encodeURIComponent(property);
					  var encodedValue = encodeURIComponent(parms[property]);
					  formBody.push(encodedKey + "=" + encodedValue);
					}
					formBody = formBody.join("&");
		
					let response = await fetch(url, {
						method: 'POST',
						headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'},
						body: formBody
					})
					let res = await response.json();
	
					if (res) {
						// Now modify the storiesFilter array to trigger a re-render.
						const index = likeButtonEntry['index'];
						let tmpLikeButtonEntries = clone(storiesFilter);
						tmpLikeButtonEntries[index]['likeCount'] = res;
		
						// console.log('DEBUG:  detected changes on likeButtonEntry');
						setStoriesFilter(tmpLikeButtonEntries);
					}
				}
			})());
		}
	}, [data.BASE_URL, likeButtonEntry, storiesFilter]);

    useEffect(() => {
        // console.log('DEBUG:  Stories - data.authToken = ', data.authToken)
		setAuthToken(data.authToken);
    }, [data, data.authToken]);

	return (
		<>
			{/* <h3>News Articles</h3> */}
			<div>
				{/* {(() => {
					console.log(`DEBUG:  RENDER - Stories - data.choicePairsList - ${JSON.stringify(data.choicePairsList)}`);
					console.log(`DEBUG:  RENDER - Stories - props.topStories - ${props.topStories}`);
				})()} */}
				{ !props.topStories && data.choicePairsList && <NavBar onClick={onSelectionChange} showFlags={!props.enableAdmin} />}

				{!props.topStories && !props.enableAdmin && <div className="filter-container">
					{/* TODO: For now I guess we are not going to enable these buttons */}
					{/* <div className='filter-row'>
						<div className="filter-btn-container" onClick={grantedPatents}>
							<div id="filter-granted-patents" className="filter-column">Granted Patents</div>
						</div>
						<div className="filter-btn-container" onClick={provisionalPatents}>
							<div id="filter-provisional-patents" className="filter-column">Provisional Patents</div>
						</div>
					</div> */}
					<div id="filter-error-status" className="filter-row filter-error filter-hide">
						<div className="filter-btn-container"></div>
					</div>
				</div>}

				<main>
					{/* {(() => {
						console.log("First Stories render: ", monetized && !isValidString(authToken));
						console.log("Stories render: ", (!monetized || (monetized && isValidString(authToken))));
					})()} */}
					{/* {monetized && !isValidString(authToken) && ( */}
					{(monetized && !props.enableAdmin) ? (
						<>
							{/* Will display a message informing the user this is a premium service and a component allowing a payment dialog to pop up */}
							<div className='story'>
								<p onClick={handlePaymentClick} className="story-monetization-message">
									This category is undergoing maintenance and monetization review
								</p>
								{/* TODO:  Comment out the pyament button stuff, maybe this will be reintroduced when we add a new payment tier. */}
								{/* This section iw 5o enable the credit card form for monetization.  We don't quite have this working as of yet so just comment out so we can get a build out. */}
								{/* {enableStripe && <CreditCardForm isOpen={isDialogOpen} onClose={(e) => {
									// console.log("onClose CreditCardForm");
									closeDialog();
								}} />} */}
							</div>
						</>
					) : (
						<>
							{storiesFilter?.length > 0 ? (
								storiesFilter.map((entry, index, arr) => {
									let link = `https://news.google.com/${entry.link}`;
									return (<div key={index} className='story'>
										{/* {(() => {
											console.log('DEBUG: ', entry)
										})()} */}
										<h1 className="story__title"><a href={link} target="_blank" rel="noreferrer">{entry.title}</a></h1>
										<div className="story__by" style={{display: entry.author ? 'block' : 'none'}}>
											{entry.author && <>
												Posted by {entry.author} - {entry.dateTime}
											</>}
											{!entry.author && <>
												{entry.dateTime}
											</>}
										</div>
										<div className="story__by" style={{display: !entry.author ? 'block' : 'none'}}>
											{entry.dateTime}
										</div>
										{/* Adding a new feature for the admin page that is only enabled 
										via URL parameter for an administrator to check off top stories that 
										will show up in the top stories section. */}
										{props.enableAdmin && <>
											{/* {(() => {
												console.log('DEBUG: ' + `RENDER: entry.topStories - ${entry?.topStoriesUI}`);
												console.log('DEBUG: ' + `RENDER: entry.tickerStorie - ${entry?.tickerStoriesUI}`);
											})()} */}
											<label className="checkbox-container right-padding">
												<input className="sr-only" type="checkbox" checked={entry.topStoriesUI} value={JSON.stringify({index, entry})} onChange={(e) => {
													setTappedTopStoryEntry({index, entry});
												}}/>
												<div className="slider"></div>
												<span className="label">Add to "Top Stories"</span>
											</label>
											{/* JHP temporarily commented out to disable the first ticker stream.  We may want this later. */}
											{/* <label className="checkbox-container">
												<input className="sr-only" type="checkbox" checked={entry.tickerStoriesUI} value={JSON.stringify({index, entry})} onChange={(e) => {
													setTappedTickerStoryEntry({index, entry});
												}}/>
												<div className="slider"></div>
												<span className="label">Add to "Article Ticker"</span>
											</label> */}
										</>}
										<div className="like-button" onClick={() => {
											setLikeButtonEntry((prevState) => {
												// console.log('DEBUG: ' + `DEBUG in Stories:  newLikeCount - ${prevState.likeCount}, originalLikeCount - ${arr[index].likeCount}`);
												return {...arr[index], index};
											});
										}}>
											{/* {likeButtonEnabled && <i className="fa fa-thumbs-up fa-1x like"> {arr[index].likeCount}</i>} */}
										</div>
									</div>)
								})
							) : (
								<>
									{/* It is either monetized or not monetized and authorized user is set so display storiesFilter but there is nothing to display. */}
									<div className="filter-error">
										{props.topStories
										? "There are no top stories as of yet, please check back later. Try back later or another category."
										: "There were no articles in this category. Try back later or another category."}
										<br />
									</div>
								</>
							)}
						</>
					)}
				</main>
			</div>
		</>
	);
}

export default Stories;
